import axios from 'axios';
import Cookies from 'js-cookie';

export const domain =
  process.env.NODE_ENV === 'development' ? null : { domain: 'mycent.kz' };
const API_HOST_BY_ENV_HOST = {
  'test2.mycent.kz': 'https://t2.mycent.kz/api',
  't2.mycent.kz': 'https://t2.mycent.kz/api',
  'test1.mycent.kz': 'https://t1.mycent.kz/api',
  't1.mycent.kz': 'https://t1.mycent.kz/api',
  'new.mycent.kz': 'https://mycent.kz/api',
  localhost: 'https://mycent.kz/api',
};

export const getApiBaseUrl = () => { 
  if (typeof window !== 'undefined') {
    const mappedBaseUrl = API_HOST_BY_ENV_HOST[window.location.hostname];

    if (mappedBaseUrl) {
      return mappedBaseUrl;
    }
  }

  return process.env.NODE_ENV === 'development'
    ? 'https://t2.mycent.kz/api'
    : '/api';
};

const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
});

axiosInstance?.interceptors.request.use(
  (config) => {
    const authToken =
      Cookies.get('token', domain) || Cookies.get('tokenBitrix'); // || localStorage.getItem('token'); // Запасной вариант на случай если в iframe Bitrix не будет работать авторизация

    return {
      ...config,
      headers: {
        Authorization: authToken ? `Bearer ${authToken}` : '',
      },
    };
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
